import React from "react";
import { useSearch } from "./SearchContext";

export interface IPerPageProps {
  selectClassName?: string;
  className?: string;
  opts?: number[];
}

export const PerPage: React.FC<IPerPageProps> = ({
  className,
  opts = [],
  selectClassName,
}) => {
  const context = useSearch();
  return (
    <div className={className}>
      Results per page:
      <select
        value={context.perPage}
        className={`mx-3 p-1 ${selectClassName}`}
        onChange={(event) => {
          context.setPerPage &&
            context.setPerPage(parseInt(event.target.value));
          context.setPage && context.setPage(1);
        }}
      >
        {opts.map((opt, index) => {
          return (
            <option key={opt} value={opt}>
              {opt || "All"}
            </option>
          );
        })}
      </select>
    </div>
  );
};
